type EmptyProps = {
  description?: string
  className?: string
  'data-testid'?: string
  /** Optional primary action mounted below the description (e.g. an add button). */
  children?: React.ReactNode
}

export function Empty({
  description = 'No data',
  className = '',
  'data-testid': dataTestId,
  children
}: EmptyProps) {
  return (
    <div
      className={`flex flex-col items-center gap-2 py-8 text-gray-400 ${className}`}
      data-testid={dataTestId}
    >
      <svg
        aria-hidden="true"
        className="h-12 w-12"
        viewBox="0 0 64 64"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <rect x="8" y="16" width="48" height="36" rx="3" />
        <path d="M24 28h16M24 36h10" strokeLinecap="round" />
      </svg>
      <p className="text-sm">{description}</p>
      {children}
    </div>
  )
}
